export default {
  path: 'temporary-regulations/item-execution/:id',
  name: 'TemporaryRegulationsItemExecutionDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ItemExecutionDetails.vue')
}
